import { ChevronDownIcon } from '@heroicons/react/24/outline';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/Dropdown';
import { Button } from '@/design-system';
import { capitalizeWords } from '@/utils/stringUtils';

export function PlaygroundOutputToggle(props: {
  enableMarkdown: boolean;
  onEnableMarkdownChange: (value: boolean) => void;
  variant: 'input' | 'output' | 'reference output';
}) {
  const subject = capitalizeWords(props.variant);

  const triggerContent = (
    <span className="text-sm font-medium">
      {!props.enableMarkdown ? `Raw ${subject}` : subject}
    </span>
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="group mb-2 inline-flex items-center gap-2 outline-none">
        <Button
          variant="plain"
          color="secondary"
          size="sm"
          rightDecorator={ChevronDownIcon}
          data-testid={`playground-output-toggle-${props.variant}`}
          className="h-auto min-h-0 bg-tertiary px-2 py-1 transition-none hover:bg-quaternary"
        >
          {triggerContent}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <DropdownMenuItem
          onClick={() => {
            props.onEnableMarkdownChange(true);
          }}
          className="flex-col items-start"
        >
          <span>Default</span>
          <span className="text-sm text-tertiary">
            Render messages with markdown support
          </span>
        </DropdownMenuItem>

        <DropdownMenuItem
          onClick={() => {
            props.onEnableMarkdownChange(false);
          }}
          className="flex-col items-start"
        >
          <span>Raw {subject}</span>
          <span className="text-sm text-tertiary">
            Render the payload received by LangSmith
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
